import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useAddUploadTrackEntryMutation } from '@/react-query/mutations/upload-track'

import { type SchemaType, schema } from './AddUploadTrackEntryForm.schema'

export interface AddUploadTrackEntryFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const AddUploadTrackEntryForm: React.FC<AddUploadTrackEntryFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const addUploadTrackEntryMutation = useAddUploadTrackEntryMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await addUploadTrackEntryMutation.mutateAsync(_data)
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
